import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function RoleSetDetial ( props ) {

    return <BasicCrudScreenType id="RoleSetDetail" table="RoleSetDetail" view="VwRoleSetDetail" />

}

export default RoleSetDetial;
